module.exports = __webpack_public_path__ + "static/clima-01-467446cbbe0d3e61b70efcedb0224b76.jpg";